export default function SectionThree () {

    
    return (
        <section className="bg-[#1E2332] w-screen h-full lg:py-20 py-4 trigs">

            <div className="lg:max-w-[82rem] lg:mx-auto text-slate-50">
                
                <h3 className="lg:text-[38px] text-[22px] font-malaya lg:text-center lg:px-60 lg:pb-10 px-4 s-three-title">Learn more <span className="text-yellow-300">about us</span> and about what we do</h3>
                
                <div className="flex flex-col gap-4 p-4 lg:p-0 lg:grid lg:grid-cols-2 lg:gap-x-16 lg:gap-y-12">

                    <div className="w-full flex flex-col lg:gap-4 gap-1.5 border-slate-400 border lg:pt-6 lg:px-8 lg:pb-8 p-4 s-left">
                        <h4 className="lg:text-[36px] text-[19px] font-malaya">Our Mission</h4>

                        <p className="lg:text-[18px] text-[15px]">To bring together community leaders to assess and meet the vital needs of the community by identifying and workings towards solutions</p>

                        <ul className="flex flex-col gap-2 text-sm">
                            <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Mobilizing community involvement
                            </li>
                            <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Developing, redirecting, and/or coordinating services</li>
                                <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Advocating for informed decisions by policy makers and contributors</li>
                                <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Linking people with community resources</li>
                        </ul>
                    </div>

                    <div className="w-full flex flex-col lg:gap-4 gap-1.5 border-slate-400 border lg:pt-6 lg:px-8 lg:pb-8 p-4 s-right"> 
                        <h4 className="lg:text-[36px] text-[19px] font-malaya">Who we are</h4>

                        <p className="lg:text-[18px] text-[15px]">The New Rochelle Council of Community Services has been working to increase the effectiveness of local social service organizations, faith based organizations, government agencies, and community members..</p>

                        <ul className="flex flex-col gap-2 text-sm">
                            <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Foster teamwork and pursue common goals
                            </li>
                            <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Faith base organisation</li>
                                <li className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                Provide higher quality services to the community</li>
                        </ul>
                    </div>

                </div>

            </div>

        </section>
    )
}